import { styled } from "styled-components";

import { MediaPlayer, SourceLabel } from "common/components";
import type { Source } from "entities/knowledge/types";

const StyledSourceLabel = styled(SourceLabel)`
  margin-top: 1.5rem;
  margin-bottom: 1rem;
  font-size: 1rem;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.textBright};
`;

const StyledVideo = styled(MediaPlayer)`
  border: none;
  overflow: hidden;
  border-radius: 5px;
  max-height: 60vh;
`;

type VideoDetailProps = {
  title: string;
  videoUrl?: string;
  html?: string;
  videoHeight?: number;
  videoWidth?: number;
  source: Source;
  timestamp: number;
};

export const VideoDetail = ({
  title,
  videoUrl,
  html,
  videoHeight,
  videoWidth,
  source,
  timestamp,
}: VideoDetailProps) => {
  if (!videoUrl && !html) return null;

  return (
    <>
      <StyledVideo
        url={videoUrl}
        isVideo={!videoUrl && !!html}
        title={title}
        html={html}
        height={videoHeight}
        width={videoWidth}
      />
      <StyledSourceLabel source={source} date={timestamp} type="small" />
    </>
  );
};
